import * as signalR from "@microsoft/signalr"
import { jwtDecode } from "jwt-decode"
import { useEffect, useMemo, useRef } from "react"
import { API_ROUTES } from "../../configuration/RoutesApi"

const normalizeToken = (token: string | null) => token?.replace(/['"]/g, "") ?? ""

const getUserId = (token: string): string | null => {
  try {
    const payload = jwtDecode<Record<string, string>>(token)

    return (
      payload.nameid ??
      payload.sub ??
      payload.userId ??
      payload.UserId ??
      payload["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"] ??
      null
    )
  } catch {
    return null
  }
}

export const useStoreDeliveryHub = (onRefresh: () => void) => {
  const refreshRef = useRef(onRefresh)
  const userId = useMemo(() => getUserId(normalizeToken(localStorage.getItem(API_ROUTES.TOKEN))), [])

  useEffect(() => {
    refreshRef.current = onRefresh
  }, [onRefresh])

  useEffect(() => {
    if (!userId) {
      return
    }

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(API_ROUTES.HUB.DELIVERY, {
        accessTokenFactory: () => normalizeToken(localStorage.getItem(API_ROUTES.TOKEN)),
      })
      .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
      .build()

    const refresh = () => refreshRef.current()
    connection.on("delivery:new", refresh)
    connection.on("delivery:status", refresh)
    connection.onreconnected(() => connection.invoke("JoinStoreGroup", userId))

    void connection
      .start()
      .then(() => connection.invoke("JoinStoreGroup", userId))
      .catch(() => undefined)

    return () => {
      void connection.stop()
    }
  }, [userId])
}
